




























































import { IWikiCategory } from "@/@types/wiki/wiki-object";
import { Component, Prop, Vue } from "vue-property-decorator";

import ButtonBack from "@/components/buttons/button-back.vue";
import ButtonCart from "@/components/buttons/button-cart.vue";
import ButtonHistory from "@/components/buttons/button-history.vue";
import StandartCategoryDd from "@/components/app/dropdowns/standart-category-dd.vue";

@Component({
  components: {
    WikiHeader,
    ButtonBack,
    ButtonCart,
    ButtonHistory,
    StandartCategoryDd,
  },
})
export default class WikiHeader extends Vue {
  @Prop({ type: Boolean, default: false }) deleted!: boolean;
  @Prop({ type: Number, default: 0 }) short_list_length!: number;
  @Prop({ type: Number, default: 0 }) full_list_length!: number;
  @Prop({ type: String, default: "" }) cat_id!: string;
  @Prop({ type: Array, default: () => [] }) cats!: Array<IWikiCategory>;
}
